import { hasBroaderAuditVisibility, hasManagementJobTitle, hasManagementRole, isSalesDashboardUser } from './dashboardRoleTiers';

const normalizeRole = (role) => String(typeof role === 'object' ? role?.name : role || '')
  .trim().toUpperCase();

export const collectDashboardRoles = (user) => [user?.role, user?.roleName, ...(Array.isArray(user?.roles) ? user.roles : [])]
  .map(normalizeRole)
  .map((role) => role && (role.startsWith('ROLE_') ? role : `ROLE_${role}`))
  .filter(Boolean);

const includesAny = (roles, candidates) => candidates.some((role) => roles.includes(role));

export const resolveDashboardProfile = (user, tasks = []) => {
  const roles = collectDashboardRoles(user);
  if (hasManagementRole(roles) || hasManagementJobTitle(user?.jobTitle)) return 'management';
  if (isSalesDashboardUser(user)) return 'sales';
  if (includesAny(roles, ['ROLE_SCHEDULER'])) return 'scheduler';
  if (includesAny(roles, ['ROLE_APPLICATION_REVIEW']) || (Array.isArray(tasks) && tasks.some((task) => ['APPLICATION_REVIEW', 'APPLICATION_REVIEW_FOLLOWUP', 'ASSIGN_NEXT_PROCESS_APPLICATION_REVIEWER'].includes(String(task?.taskTypeCode || '').toUpperCase())))) return 'application-review';
  if (includesAny(roles, [
    'ROLE_TECHNICAL', 'ROLE_TECHNICAL_EXPERT', 'ROLE_TECHNICAL_REVIEW', 'ROLE_TECHNICAL_REVIEWER',
    'ROLE_CERTIFICATE_ISSUANCE', 'ROLE_CERTIFICATE_DECISION', 'ROLE_CERTIFICATION_ISSUER',
    'ROLE_CERTIFICATION_REVIEW', 'ROLE_CERTIFICATE_REVIEWER', 'ROLE_CERTIFICATION_REVIEWER',
    'ROLE_CERTIFICATION_AUTHORITY',
  ]) || hasBroaderAuditVisibility(tasks)) return 'technical-certification';
  return 'auditor';
};

export const profileNeedsClientMonitoring = (profile) => (
  ['sales', 'application-review', 'scheduler', 'auditor', 'technical-certification', 'management'].includes(profile)
);

export const profileNeedsUtilization = (profile) => (
  ['scheduler', 'technical-certification', 'management'].includes(profile)
);

export const profileNeedsCertificateHealth = (profile) => (
  ['technical-certification', 'management'].includes(profile)
);
